import useNewToggle from "../../../../hooks/useNewToggle";
import { Inset, Popover } from "@radix-ui/themes";
import { GoSmiley } from "react-icons/go";
import CLASSNAME from "./classname";
import SIZE from "./size";
import { ReactionPanel } from "../panels";

const ReactionControl = () => {
  const [isOn, toggleReaction, setIsOn] = useNewToggle();

  return (
    <div className="relative group">
      <Popover.Root open={isOn} onOpenChange={setIsOn}>
        <Popover.Trigger>
          <div
            className="flex h-12 w-12  largescreen:h-14 largescreen:w-14 items-center justify-center rounded-full cursor-pointer mobile:hidden"
            style={{
              background: "rgb(95, 72, 138)",
              boxShadow:
                "rgb(152, 122, 209) -8px -8px 16px inset, rgba(2, 2, 2, 0.61) 8px 8px 8px inset",
            }}
            onClick={toggleReaction}
          >
            <GoSmiley color="white" size={SIZE} />
          </div>
        </Popover.Trigger>
        <Popover.Content style={{ width: 300 }}>
          <Inset>
          <ReactionPanel onClose={() => setIsOn(false)} />
          </Inset>
        </Popover.Content>
      </Popover.Root>
      <div className="absolute bottom-full mb-2 left-1/2 transform -translate-x-1/2 max-w-md bg-black text-white text-sm rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        Reactions
      </div>
    </div>
  );
};

export default ReactionControl;
